// components/parcours-client/SerieVehicleStep.js
import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Divider,
  Paper
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useTranslation } from "react-i18next";

const SerieVehicleStep = ({
  formData,
  setFormData,
  handleNext,
  handleBack,
  goToStepOne,
}) => {
  const { t } = useTranslation("parcours-client/SerieVehicleStep");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!formData.numeroSerie) {
      setError(t("errors.required"));
    } else {
      setError("");
      handleNext();
    }
  };

  const fieldStyle = {
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "#4eb933" },
      "&:hover fieldset": { borderColor: "#4eb933" },
      "&.Mui-focused fieldset": { borderColor: "#4eb933" },
    },
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", px: 2, mt: 6 }}>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: "800px",
          borderRadius: "20px",
          px: { xs: 3, md: 6 },
          pt: { xs: 4, md: 6 },
          pb: { xs: 4, md: 5 },
          backgroundColor: "#F8F8F8",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        {/* Titre */}
        <Typography
          sx={{
            fontWeight: 900,
            fontSize: { xs: "2rem", md: "2.4rem" },
            color: "#000",
            mb: 3,
            textAlign: "center",
          }}
        >
          {t("title.part1")}{" "}
          <Box component="span" sx={{ color: "#4eb933" }}>
            {t("title.highlight")}
          </Box>
        </Typography>

        {/* Champ numéro de série */}
        <TextField
          fullWidth
          label={t("fields.serial")}
          value={formData.numeroSerie || ""}
          onChange={(e) =>
            setFormData({ ...formData, numeroSerie: e.target.value })
          }
          error={!!error}
          helperText={error}
          sx={{ mb: 4, ...fieldStyle }}
        />

        {/* Récapitulatif */}
        <Box sx={{ mb: 4 }}>
          <Typography fontWeight={700} fontSize="1.1rem" mb={1}>
            {t("recap.title")}
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Paper
            elevation={1}
            sx={{
              p: 3,
              borderRadius: 3,
              backgroundColor: "#f4f4f4",
            }}
          >
            <Typography sx={{ mb: 1.2 }}>
              <strong>{t("recap.type")} :</strong> {formData.bikeType || "-"}
            </Typography>
            <Typography sx={{ mb: 1.2 }}>
              <strong>{t("recap.brand")} :</strong> {formData.marque || "-"}
            </Typography>
            <Typography sx={{ mb: 1.2 }}>
              <strong>{t("recap.model")} :</strong> {formData.modele || "-"}
            </Typography>
            <Typography sx={{ mb: 1.2 }}>
              <strong>{t("recap.price")} :</strong>{" "}
              {formData.prix || formData.prix === 0 ? `${formData.prix} €` : "-"}
            </Typography>
            <Typography sx={{ mb: 1.2 }}>
              <strong>{t("recap.purchaseDate")} :</strong>{" "}
              {formData.dateAchat || "-"}
            </Typography>
          </Paper>
        </Box>

        {/* Bouton "Modifier les informations" */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Button
            variant="outlined"
            onClick={goToStepOne}
            sx={{
              textTransform: "none",
              borderRadius: "12px",
              fontWeight: 600,
              color: "#4d4d4d",
              borderColor: "#4d4d4d",
              "&:hover": { backgroundColor: "#f0f0f0" },
            }}
          >
            {t("actions.edit")}
          </Button>
        </Box>

        {/* Boutons navigation */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column-reverse", sm: "row" },
            justifyContent: { xs: "center", sm: "space-between" },
            gap: 2,
            mt: 4,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleBack}
            startIcon={<ArrowBackIosIcon />}
            fullWidth
            sx={{
              textTransform: "none",
              borderRadius: "12px",
              fontWeight: 600,
              fontSize: { xs: "0.95rem", md: "1rem" },
              py: 1.2,
            }}
          >
            {t("actions.prev")}
          </Button>

          <Button
            variant="contained"
            onClick={handleSubmit}
            endIcon={<ArrowForwardIosIcon sx={{ fontSize: 16 }} />}
            fullWidth
            sx={{
              backgroundColor: "#4eb933",
              color: "#fff",
              "&:hover": { backgroundColor: "#3e9e2a" },
              fontWeight: 700,
              borderRadius: "12px",
              textTransform: "none",
              fontSize: { xs: "0.95rem", md: "1rem" },
              py: 1.2,
              px: 3,
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            {t("actions.next")}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default SerieVehicleStep;